const ChevronLeftSvg = ( { className } ) => {
	return (
		<svg
			width="100%"
			viewBox="0 0 35 50"
			className={className}>
			<path
				d="M30 45L9.39394 24.9998L30 5"
				stroke="currentColor"
				strokeWidth="12" />
		</svg>
	);
};
export default ChevronLeftSvg;
